import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import TinyUrlTable from '../Components/TinyUrlTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedTinyUrl, setSelectedTinyUrl] = useState(undefined);
    const [selectedTinyUrlValue, setSelectedTinyUrlValue] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: tinyUrls, loading }, refetch] = useAxios("resources/content/admin/tinyurls");

    if (loading) return <Spinner className="absolute-center" label="Loading Tiny Urls..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Tiny Url Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <TinyUrlTable
                tinyUrls={tinyUrls && tinyUrls.length > 0 ? tinyUrls.sort((a, b) => b.tinyUrlId - a.tinyUrlId) : []}
                setSelectedTinyUrl={setSelectedTinyUrl}
                selectedTinyUrl={selectedTinyUrl}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, tinyUrlValue) => {
                    setSelectedTinyUrl(id);
                    setSelectedTinyUrlValue(tinyUrlValue || "");
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`resources/content/admin/tinyurls/delete/${selectedTinyUrl}/`}
                resourceName={selectedTinyUrlValue}
                resourceType="tiny url"
                confirmationValue={selectedTinyUrlValue || undefined}
            />
        </>
    );
};

export default DefaultPage;
